// @flow
import React from 'react';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';
import { Text } from 'bench-internal-theme';

import { type DataEntry } from './types';
import getFormattedCentsAmount from './getFormattedCentsAmount';

const StyledTable = styled.table`
  width: 100%;

  td {
    vertical-align: top;
    border-bottom: 1px solid ${colors.silt};
    &.-amount-cell {
      text-align: right;
    }
  }

  tr:last-child td {
      border-bottom: none;
    }
  }
`;

type DataEntriesProps = {
  dataEntryList: Array<DataEntry>,
};

/**
 * Displays all data entries in a formatted table
 *
 * @param dataEntryList - a list of debit and credit data entries
 */
const DataEntries = ({ dataEntryList }: DataEntriesProps) => (
  <StyledTable>
    <tbody>
      {dataEntryList.map(({ id, amountInCents, ledgerAccount }) => (
        <tr key={id}>
          <td>
            <Text styleType="small">{ledgerAccount.name}</Text>
          </td>
          {amountInCents >= 0 ? (
            <td className="-amount-cell">
              <Text styleType="smallBold" color={colors.bonsai}>
                {getFormattedCentsAmount(amountInCents)}
              </Text>
            </td>
          ) : (
            <td />
          )}
          {amountInCents < 0 ? (
            <td className="-amount-cell">
              <Text styleType="smallBold" color={colors.copper}>
                {getFormattedCentsAmount(amountInCents)}
              </Text>
            </td>
          ) : (
            <td />
          )}
        </tr>
      ))}
    </tbody>
  </StyledTable>
);

export default DataEntries;
